<template>
  <div>
    <div>
      <qd-message
            type="is-info"
            v-if="hasNoLieuDeStockage && isOtImpression"
            :title="$t('addEditOrdreTravailTech.patrimoine.noPat.warTitle')"
            aria-close-label="Close message">
            {{ $t('addEditOrdreTravailTech.patrimoine.noPat.warnNoSelectPat')}}
        </qd-message>
    </div>
    <div v-if="!ordreTravail.otPatrimoine">
      <div class="card mgt-20px">
        <div class="card-content has-text-centered pd-40px">
          <h1 class="title is-size-3">
            {{ $t('addEditOrdreTravailTech.patrimoine.noPat.title')}}
          </h1>
          <a class="lien" @click="$emit('goToUpdatePatrimoine')">
            {{ $t('addEditOrdreTravailTech.patrimoine.noPat.associe')}}
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card mgt-20px">
        <div class="card-content">
          <info-modifiable-emplacement  v-if="ordreTravail.otPatrimoine
          && ordreTravail.otPatrimoine.emplacement"
                                        :emplacementTechnique=
                                          "ordreTravail.otPatrimoine.emplacementTechnique">
          </info-modifiable-emplacement>
          <info-modifiable-dispositif v-if="ordreTravail.otPatrimoine
          && ordreTravail.otPatrimoine.dispositif"
                                      :otPatrimoineAccessoires=
                                        "ordreTravail.otPatrimoine.otPatrimoineAccessoires"
                                      :societe-id="societeId"
                                      :dispositifTechnique=
                                        "ordreTravail.otPatrimoine.dispositifTechnique">
          </info-modifiable-dispositif>
          <info-modifiable-materiel v-if="ordreTravail.otPatrimoine
          && ordreTravail.otPatrimoine.materiel"
            :materielTechnique="ordreTravail.otPatrimoine.materielTechnique">
          </info-modifiable-materiel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import infoModifiableDispositif
  from '@/components/logistique/ordreTravail/tech/addEdit/patrimoine/infoModifiableDispositif';
import infoModifiableEmplacement
  from '@/components/logistique/ordreTravail/tech/addEdit/patrimoine/infoModifiableEmplacement';
import infoModifiableMateriel
  from '@/components/logistique/ordreTravail/tech/addEdit/patrimoine/infoModifiableMateriel';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'LogistiqueOrdreTravailTechniqueEditPatrimoine',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    typeOts() {
      return this.parametre(PARAMETRES_KEYS.typeOt) ?? [];
    },
    hasNoLieuDeStockage() {
      return !this.ordreTravail?.otStock?.lieuDeStockageId;
    },
    isOtImpression() {
      if (!this.ordreTravail?.typeOtId) return false;
      return this.typeOts
        .find(t => t.id === this.ordreTravail.typeOtId)
        ?.actionInterventionOt === IMPRESSION_AFFICHE;
    },
  },
  components: {
    infoModifiableDispositif,
    infoModifiableEmplacement,
    infoModifiableMateriel,
  },
};

</script>
